module.exports = __webpack_public_path__ + "img/youtube-hnz.aa87448e.jpeg";